var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.8551C6.825 1.8551 7.5 2.5301 7.5 3.3551C7.5 4.1801 6.825 4.8551 6 4.8551C5.175 4.8551 4.5 4.1801 4.5 3.3551C4.5 2.5301 5.175 1.8551 6 1.8551ZM6 9.3551C8.025 9.3551 10.35 10.3226 10.5 10.8551H1.5C1.6725 10.3151 3.9825 9.3551 6 9.3551ZM6 0.355103C4.3425 0.355103 3 1.6976 3 3.3551C3 5.0126 4.3425 6.3551 6 6.3551C7.6575 6.3551 9 5.0126 9 3.3551C9 1.6976 7.6575 0.355103 6 0.355103ZM6 7.8551C3.9975 7.8551 0 8.8601 0 10.8551V12.3551H12V10.8551C12 8.8601 8.0025 7.8551 6 7.8551Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.110863309d06804130a4ed118c94f088.svg";
export { ForwardRef as ReactComponent };